module.exports = __webpack_public_path__ + "static/media/card-3.50bb8448.png";